<template>
  <!--
    A CONQUISTA DESBLOQUEADA, na folha empilhada do Paper Pack — o selo grande no papel, como no
    caderno. Os fogos de CSS (pyro) saíram; a celebração é o som de captura, que ficou.
  -->
  <div v-if="show" class="conquista" role="dialog" :aria-label="$t('rewards.newAchievement')">
    <Transition name="conquista-troca" mode="out-in">
      <div v-if="showContent" :key="currentIndex" class="conquista__papel papel-empilhado subir-surgindo">
        <p class="conquista__rotulo">{{ $t('rewards.newAchievement') }}</p>

        <img class="conquista__selo" :src="getItemImage(currentReward)" :alt="currentReward" />

        <p class="conquista__nome">{{ $t(`rewards.titles.${currentReward}`) }}</p>

        <FishButton variante="primario" bloco som="recompensa" @click="handleNextReward">
          {{ $t(getButtonText) }}
        </FishButton>
      </div>
    </Transition>
  </div>
</template>

<script>
import { getItemImage } from '@/shared/utils/rewardImages';
import { FishButton } from '@/shared/ui';

export default {
  name: 'RewardView',
  components: { FishButton },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    rewards: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close'],
  data() {
    return {
      currentIndex: 0,
      showContent: false
    }
  },
  computed: {
    currentReward() {
      return this.rewards[this.currentIndex];
    },
    getButtonText() {
      return this.currentIndex < this.rewards.length - 1
        ? 'rewards.next'
        : 'rewards.claim';
    }
  },
  methods: {
    getItemImage,
    async handleNextReward() {
      this.showContent = false;
      await new Promise(resolve => setTimeout(resolve, 300));

      if (this.currentIndex < this.rewards.length - 1) {
        this.currentIndex++;
        this.showReward();
      } else {
        this.$emit('close');
      }
    },
    async showReward() {
      await this.$store.dispatch('SoundController/playSound', {
        category: 'fishing',
        type: 'catch'
      });
      this.showContent = true;
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.currentIndex = 0;
          this.showReward();
        }
      }
    }
  }
}
</script>

<style scoped>
.conquista {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--e-3);
  background: var(--veu);
}

.conquista__papel {
  --folha: 360px;
  width: min(360px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--e-3);
  text-align: center;
}

.conquista__rotulo {
  margin: 0;
  font-family: var(--fonte-display);
  font-size: var(--f-3);
  color: var(--tinta);
}

.conquista__selo {
  width: 112px;
  height: 112px;
  object-fit: contain;
  image-rendering: auto;
}

.conquista__nome {
  margin: 0;
  font-family: var(--fonte-display);
  font-size: var(--f-2);
  color: var(--tinta-fraca);
}

.conquista-troca-enter-active,
.conquista-troca-leave-active {
  transition: opacity var(--t-medio) var(--curva-suave), transform var(--t-medio) var(--curva-suave);
}

.conquista-troca-enter-from,
.conquista-troca-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
